import { render, staticRenderFns } from "./DashboardInfo.vue?vue&type=template&id=8df26c80&scoped=true"
var script = {}
import style0 from "./DashboardInfo.vue?vue&type=style&index=0&id=8df26c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df26c80",
  null
  
)

export default component.exports